export const getAuthToken = () => {
    return localStorage.getItem('ibxAdminAuthToken:token');
};
export const setAuthToken = (token: string) =>
    localStorage.setItem('ibxAdminAuthToken:token', token);
export function currencyFormater(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
export const setAdminId = (id: string) =>
    localStorage.setItem('ibxAdminId', id);

export const getAdminId = () => {
    return localStorage.getItem('ibxAdminId');
};
